var FORM_ACTION_STATUS;
(function (FORM_ACTION_STATUS) {
    FORM_ACTION_STATUS["PENDING"] = "pending";
    FORM_ACTION_STATUS["SUCCESS"] = "success";
    FORM_ACTION_STATUS["FAILURE"] = "failure";
})(FORM_ACTION_STATUS || (FORM_ACTION_STATUS = {}));
export const createControllerActions = ({ formActions, formActionApis, setProps, resolveError, }) => {
    let formActionsResults = {};
    const updateFormResults = (formResult) => {
        formActionsResults = {
            ...formActionsResults,
            ...formResult,
        };
        setProps({ wfResults: formActionsResults });
    };
    const actions = Object.entries(formActions).reduce((accumulator, [actionName, getFormActionFunction]) => {
        const formActionFunction = getFormActionFunction(formActionApis);
        return {
            ...accumulator,
            [actionName]: async (correlationId, ...args) => {
                updateFormResults({
                    [correlationId]: {
                        status: FORM_ACTION_STATUS.PENDING,
                        result: undefined,
                    },
                });
                try {
                    const result = await formActionFunction(...args);
                    updateFormResults({
                        [correlationId]: {
                            status: FORM_ACTION_STATUS.SUCCESS,
                            result,
                        },
                    });
                }
                catch (error) {
                    const resolvedError = resolveError(error);
                    updateFormResults({
                        [correlationId]: {
                            status: FORM_ACTION_STATUS.FAILURE,
                            result: resolvedError,
                        },
                    });
                }
            },
        };
    }, {});
    return actions;
};
//# sourceMappingURL=create-controller-actions.js.map